import { FadeIn } from "../components/FadeIn";
import { PageHeader } from "../components/PageHeader";
import { Section, Overline, Divider, PullQuote, AmfButton } from "../components/Primitives";
import { IMAGES, VALUES_TEXT, APPROACH } from "../data/content";
import { useContent } from "../context/ContentContext";

export default function About() {
  const { t } = useContent();
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow={t("about.header.eyebrow")}
        title={t("about.header.title")}
        intro={t("about.header.intro")}
        image={IMAGES.classroomReading}
      />

      {/* OUR STORY */}
      <Section className="bg-amf-cream">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <FadeIn className="lg:col-span-5">
            <Overline>Our Story</Overline>
            <h2 className="font-playfair text-3xl md:text-4xl text-amf-navy mt-3 leading-tight">
              {t("about.story.heading")}
            </h2>
          </FadeIn>
          <FadeIn delay={0.12} className="lg:col-span-7 font-lora text-lg leading-relaxed text-amf-charcoal/85 space-y-5">
            <p>{t("about.story.p1")}</p>
            <p>{t("about.story.p2")}</p>
          </FadeIn>
        </div>
      </Section>

      {/* MISSION & VISION */}
      <Section className="bg-amf-navy">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          <FadeIn>
            <Overline light>Our Mission</Overline>
            <p className="font-lora text-xl text-amf-cream/90 mt-5 leading-relaxed">
              {t("about.mission.text")}
            </p>
          </FadeIn>
          <FadeIn delay={0.12}>
            <Overline light>Our Vision</Overline>
            <p className="font-lora text-xl text-amf-cream/90 mt-5 leading-relaxed">
              {t("about.vision.text")}
            </p>
          </FadeIn>
        </div>
      </Section>

      {/* VALUES */}
      <Section className="bg-amf-cream">
        <FadeIn className="max-w-3xl mx-auto text-center">
          <Overline>Our Values</Overline>
          <p className="font-playfair text-2xl md:text-3xl text-amf-navy mt-5 leading-snug">
            {t("about.values.text", VALUES_TEXT)}
          </p>
        </FadeIn>
      </Section>

      {/* MESSAGE FROM ED */}
      <Section className="bg-[#F4F6F8]">
        <Overline>Message from the Executive Director</Overline>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 mt-8 items-start">
          <FadeIn className="lg:col-span-4">
            <img
              src={IMAGES.executiveDirector}
              alt="Madam Ayisha Malik, Founder & Executive Director"
              className="w-full aspect-[3/4] object-cover amf-img"
            />
            <p className="font-playfair text-xl text-amf-navy mt-4">
              {t("about.ed.name")}
            </p>
            <p className="amf-overline text-amf-stone mt-1">
              {t("about.ed.role")}
            </p>
          </FadeIn>
          <FadeIn delay={0.12} className="lg:col-span-8 font-lora text-lg leading-relaxed text-amf-charcoal/85 space-y-5">
            <p>{t("about.ed.p1")}</p>
            <p>{t("about.ed.p2")}</p>
            <p>{t("about.ed.p3")}</p>
            <p className="font-playfair italic text-amf-navy text-xl">
              — {t("about.ed.name")}, {t("about.ed.role")}
            </p>
          </FadeIn>
        </div>
      </Section>

      {/* APPROACH & STRATEGY */}
      <Section className="bg-amf-cream">
        <FadeIn>
          <Overline>Our Approach &amp; Strategy</Overline>
          <h2 className="font-playfair text-3xl md:text-4xl text-amf-navy mt-3">
            Four commitments that anchor our work
          </h2>
        </FadeIn>
        <Divider className="my-10" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
          {APPROACH.map((a, i) => (
            <FadeIn key={i} delay={i * 0.08} className="flex gap-5 items-start">
              <span className="font-playfair text-3xl text-amf-gold leading-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-lora text-lg text-amf-charcoal/85 leading-relaxed pt-1">
                {a}
              </p>
            </FadeIn>
          ))}
        </div>
        <div className="mt-12">
          <AmfButton to="/areas-of-focus" variant="outline">
            Explore Our Areas of Focus
          </AmfButton>
        </div>
      </Section>
    </div>
  );
}
